/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { isEmpty, cloneDeep, get } from 'lodash';
import { DimensionType, DimensionOptionGroupType } from '../types';

export const findFirstNotUsedAttributeOption = (selectedItems: any[], options: any[], attributeType: DimensionType) => {
  const selectedAttributeValues = selectedItems.filter(a => a.name.type === attributeType).map(a => a.name.value);
  const selectedCustomAttributeValues = selectedItems
    .filter(a => a.name.type === DimensionType.CUSTOM_ATTRIBUTE)
    .map(a => a.name.value);

  const attributeOptions = cloneDeep(options);

  if (!isEmpty(options[DimensionOptionGroupType.ATTRIBUTE])) {
    attributeOptions[DimensionOptionGroupType.ATTRIBUTE].dimensions = options[
      DimensionOptionGroupType.ATTRIBUTE
    ].dimensions.filter(d => !selectedAttributeValues.includes(d.value));
    if (!isEmpty(attributeOptions[DimensionOptionGroupType.ATTRIBUTE].dimensions)) {
      return attributeOptions[DimensionOptionGroupType.ATTRIBUTE].dimensions[0];
    }
  }

  if (!isEmpty(options[1])) {
    attributeOptions[DimensionOptionGroupType.CUSTOM_ATTRIBUTE].dimensions = options[
      DimensionOptionGroupType.CUSTOM_ATTRIBUTE
    ].dimensions.filter(d => !selectedCustomAttributeValues.includes(d.value));
    if (!isEmpty(attributeOptions[DimensionOptionGroupType.CUSTOM_ATTRIBUTE].dimensions)) {
      return attributeOptions[DimensionOptionGroupType.CUSTOM_ATTRIBUTE].dimensions[0];
    }
  }

  // TO DO: add support for tags here

  return {};
};

export const findUnusedAttributeOptions = (
  selectedItems: any[],
  options: any[],
  index: number,
  attributeType: DimensionType
) => {
  // filter out used attributes for same object type
  const selectedAttributeValues = selectedItems
    .filter((a, i) => {
      return a.name.type === attributeType && i !== index && sameObjectType(selectedItems, i, index);
    })
    .map(a => a.name.value);

  const selectedCustomAttributeValues = selectedItems
    .filter((a, i) => a.name.type === DimensionType.CUSTOM_ATTRIBUTE && i !== index)
    .map(a => a.name.value);

  const attributeOptions = cloneDeep(options);

  if (!isEmpty(attributeOptions[0])) {
    attributeOptions[DimensionOptionGroupType.ATTRIBUTE].dimensions = options[
      DimensionOptionGroupType.ATTRIBUTE
    ].dimensions.filter(d => !selectedAttributeValues.includes(d.value));
  }

  if (!isEmpty(attributeOptions[DimensionOptionGroupType.CUSTOM_ATTRIBUTE])) {
    attributeOptions[DimensionOptionGroupType.CUSTOM_ATTRIBUTE].dimensions = options[
      DimensionOptionGroupType.CUSTOM_ATTRIBUTE
    ].dimensions.filter(d => !selectedCustomAttributeValues.includes(d.value));
  }

  return attributeOptions;
};

function sameObjectType(items, i, index) {
  if (items[i] && items[index] && i !== index) {
    const obj1 = get(items[i], 'object');
    const obj2 = get(items[index], 'object');

    if (obj1 && obj2) return obj1.value === obj2.value;
    return true;
  }
}
